import { CrudStoreBase } from './crudStoreBase';
import { ReferralContestDto } from '../services/referralContest/dto/referralContestDto';
import ReferralContestService from '../services/referralContest/referralContestService';
import { PagedResultRequestDto } from '../services/base/pagedResultRequestDto';

class ReferralContestStore extends CrudStoreBase<ReferralContestDto>{
  constructor() {
    super(ReferralContestService, defaultReferralContest)
  }

  public async getAll(request: PagedResultRequestDto  & {customerId : number} | PagedResultRequestDto  & {contestId: number, onlyEligible: boolean}) {
      if(!request) return

      if('contestId' in request) {
        await ReferralContestService.getParticipants(
          request.contestId, 
          {
            keyword: request.keyword ? request.keyword : this.defaultRequest.keyword, 
            skipCount: request.skipCount ? request.skipCount : this.defaultRequest.skipCount, 
            sorting: request.sorting ? request.sorting : this.defaultRequest.sorting, 
            maxResultCount: request.maxResultCount ? request.maxResultCount : this.defaultRequest.maxResultCount
          },
          request.onlyEligible
        ).then((result: any) => {
          this.dataSet = result;
        }).catch((error: any) => {
          console.error(error);
        });
      } else {
        await super.getAll(request);
      }
  }
}

export const defaultReferralContestCondition = {
  referralContestId: 0,
  productType: '',
  minPrice: 0,
  maxPrice: 0,
};

export const defaultReferralContest = {
  id: '',
  name: '',
  isEnabled: false,
  startDate: '',
  endDate: '',
  imageUrl: '',
  scale: 0,
  descriptionTitle: '',
  section1Name: '',
  section1Description: '',
  section2Name: '',
  section2Description: '',
  description: '',
  receivedPromotionDescription: '',
  bonusAmount: 0,
  creationTime: '',
  creatorUserId: 0,
  lastModificationTime: '',
  lastModifierUserId: 0,
  participantsAmount: 0,
  productType: '',
  promotionRules: '',
  contestConditions: [
    {...defaultReferralContestCondition}
  ],
};

export default ReferralContestStore;